<template>
  <div class="dropdown header-notify pl-4">
    <a @click="loadNotifications" class="nav-link position-relative cursor-pointer" data-toggle="dropdown">
      <span class="position-relative d-inline-block">
        <img
          :src="newNotifications > 0 ? '/static/images/icons/notification-recieved.png' : '/static/images/icons/notifications.png'"
          alt="notifications"
          class="img-fluid ic position-relative"
        >
        <span v-if="newNotifications > 0" class="badge-count">
          {{ newNotifications > 99 ? '99+' : newNotifications }}
        </span>
        <span v-if="newNotifications > 0" class="pulse"></span>
      </span>
    </a>
    <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow animated">
      <sk-list v-if="loading" :height="0.2" :items-count="4"></sk-list>
      <div v-else class="dropdown-menu-items">
        <div v-if="notifications.length === 0" class="no-notifications">
          {{ $t('notifications.not-found') }}
        </div>
        <notification-item
          :key="$index"
          v-for="(notification, $index) of notifications"
          :item="notification"
          @seen="setSeen"
        ></notification-item>
      </div>
      <div class="text-center p-2 border-top">
        <a @click.prevent="seeAll()" href="#">{{ $t('notifications.mark-all-as-read') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
  import NotificationItem from './notification-item';
  import { mapGetters } from 'vuex';
  import SkList from './skeletons/sk-list';

  export default {
    name: 'notifications',
    components: { SkList, NotificationItem },

    data() {
      return {
        page: 1,
        per_page: 20,
        pollInterval: null,
      };
    },

    computed: {
      ...mapGetters({
        notifications: 'notifications/notifications',
        loading: 'notifications/loading',
        newNotifications: 'notifications/newNotifications'
      })
    },

    mounted() {
      this.startPolling();
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    },

    beforeDestroy() {
      this.stopPolling();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    },

    methods: {
      setSeen(notification) {
        this.$store.dispatch('notifications/seen', notification.notificationID)
          .then(() => {
            if (notification.link) this.$router.push(notification.link).catch(() => {});
          });
      },

      seeAll() {
        this.$store.dispatch('notifications/seeAll');
      },

      loadNotifications() {
        this.$store.dispatch('notifications/loadNotifications', {
          page: this.page, per_page: this.per_page
        });
      },

      startPolling() {
        this.pollInterval = setInterval(() => {
          this.$store.dispatch('notifications/loadCounts');
        }, 60000);
      },

      stopPolling() {
        if (this.pollInterval) clearInterval(this.pollInterval);
      },

      onVisibilityChange() {
        if (document.visibilityState === 'visible') {
          this.$store.dispatch('notifications/loadCounts');
        }
      },
    }
  };
</script>

<style scoped>
  .no-notifications {
    font-weight: bold;
    text-align: center;
    font-size: 14px;
    min-height: 56px;
  }
  .dropdown-menu {
    padding: 1.4rem 0 0 0;
    min-width: 26.5rem;
  }
  .dropdown-menu-items {
    max-height: 300px;
    overflow-y: auto;
  }
  .dropdown-menu-items::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  .dropdown-menu-items::-webkit-scrollbar-thumb {
    background: #c2c2c2;
    border-radius: 5px;
    -webkit-box-shadow: unset;
  }
  .dropdown-menu-items::-webkit-scrollbar-thumb:hover {
    background: #c2c2c2;
    -webkit-box-shadow: unset;
  }
  .dropdown-menu-items::-webkit-scrollbar-track {
    padding-left: 1rem;
    background: #f2f2f2;
    -webkit-box-shadow: inset 0 0 6px transparent;
    border-radius: 0;
  }
  .badge-count {
    position: absolute;
    top: -6px;
    right: -8px;
    background: #e53935;
    color: #fff;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    min-width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    padding: 0 4px;
    pointer-events: none;
  }
</style>
